import { styled, tableCellClasses, tableRowClasses } from '@mui/material';
import { Box, Stack, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { Card, CardContent as BaseCardContent, CardHeader, CapitalizeTypography } from './CampaignWizardStyles';

// import { AudienceSource } from '../../../../types/AudienceSource';
import { Campaign } from '../../../../types/Campaign';
import { CampaignWizardStepProps } from './CampaignWizard';
// import { InventorySource } from '../../../../types/Inventory';
// import { Location } from '../../../../types/Location';
import { ProductCategory } from '../../../../components/ProductCategoryAutocomplete';
import { useCampaignAdGroupAudienceSourceSummary } from '../../../../hooks/Models/Campaign/CampaignAdGroupAudienceSourceSummary';
import { useCampaignAdGroupGeoLocationSummary } from '../../../../hooks/Models/Campaign/CampaignAdGroupGeoLocationSummary';
import { useCampaignAdGroupInventorySourceSummary } from '../../../../hooks/Models/Campaign/CampaignAdGroupInventorySourceSummary';
import { useCampaignAdGroupLocationSummary } from '../../../../hooks/Models/Campaign/CampaignAdGroupLocationSummary';
import { useCampaignWizardContext } from '../../../../hooks/useCampaignWizard';
import { useCodeList } from '../../../../hooks/Models/CodeList';
import { Table, TablePrimaryCell as BaseTablePrimaryCell } from '../../../../components/Table';
import { useUserContext } from '../../../../hooks/Contexts/UserContext';
import AudienceSourceField from '../../../../components/Audience/AudienceSourceField';
import CampaignAudienceTypeSummary from '../../../../features/Campaign/CampaignAudienceTypeSummary';
import CampaignFrequencySummary from '../../../../features/Campaign/CampaignFrequencySummary';
import CampaignCreativeAssets from './CampaignCreativeAssets';
import Column from '../../../../components/Column';
import InventorySourceField from '../../../../components/Inventory/InventorySourceField';
import LocationList from '../../../../components/Location/LocationList';
import DspAudienceSourceUtils from '../../../../utils/DspAudienceSourceUtils';
import DspGeoLocationUtils from '../../../../utils/DspGeoLocationUtils';
import Utils from '../../../../components/Utils';
import { getFlightStatusBadge, calculateFlightSummary } from '../../../../utils/FlightStatusUtils';

const CardContent = styled(BaseCardContent)(({ theme }) => ({
    '&': { padding: 0 },
    '&:last-child': { paddingBottom: 0 },
    [`&:last-child .${tableRowClasses.root}:last-child .${tableCellClasses.root}`]: { borderBottomWidth: 0 },
}));

const TablePrimaryCell = styled(BaseTablePrimaryCell)(({ theme }) => ({
    '&': { width: '30%' },
}));

type CampaignReviewDetailedSummaryProps = {
    onChange?: (value: Partial<Campaign>) => void;
} & Omit<CampaignWizardStepProps, 'onChange'>;

export default function CampaignReviewDetailedSummary(props: CampaignReviewDetailedSummaryProps) {
    const { campaign } = props;
    const { userContext } = useUserContext();
    const { campaignBidStrategyLabel, campaignBudgetManagementStrategyLabel } = useCampaignWizardContext();

    const { $productCategories } = useCampaignWizardContext();
    const { getCampaignProductCategory = (campaign: Campaign): ProductCategory | null => null } =
        $productCategories || {};
    const productCategory: ProductCategory | null = getCampaignProductCategory(campaign);

    // const locationCount = campaign?.adGroups?.[0]?.adGroupLocations?.length ?? 0;
    // const geoLocationCount = campaign?.adGroups?.[0]?.adGroupGeoLocations?.length ?? 0;
    // const audienceSourceCount = campaign?.adGroups?.[0]?.adGroupAudienceSources?.length ?? 0;

    // const { $audienceSources } = useCampaignWizardContext();
    // const { audienceSources: selections = [], getCampaignAudienceSources = undefined } = $audienceSources || {};
    // const [audienceSources, setAudienceSources] = useState<AudienceSource[]>([]);

    const { targetCount: audienceSourceTargetCount, targetQuery: audienceSourceTargetQuery } =
        useCampaignAdGroupAudienceSourceSummary({ campaign });
    const { targetCount: geoLocationTargetCount, targetQuery: geoLocationTargetQuery } =
        useCampaignAdGroupGeoLocationSummary({ campaign });
    const { targetQuery: inventorySourceTargetQuery } = useCampaignAdGroupInventorySourceSummary({ campaign });
    const { targetCount: locationTargetCount, targetQuery: locationTargetQuery } = useCampaignAdGroupLocationSummary({
        campaign,
    });

    // const { $inventorySources } = useCampaignWizardContext();
    // const { inventorySources: inventorySourceSelections = [], getCampaignInventorySources = undefined } =
    //     $inventorySources || {};
    // const [inventorySources, setInventorySources] = useState<InventorySource[]>([]);

    // const { $locations } = useCampaignWizardContext();
    // const {
    //     locations: locationSelections = [],
    //     getCampaignLocations = undefined,
    //     getCampaignGeoLocations = undefined,
    //     fetchLocations,
    // } = $locations || {};
    // const [locations, setLocations] = useState<Location[]>([]);
    // const [geoLocations, setGeoLocations] = useState<Location[]>([]);

    const { getCodeDescription: getCampaignTypeCodeDescription } = useCodeList({ codeGroup: 'CampaignType' });
    const { getCodeDescription: getGoalTypeCodeDescription } = useCodeList({ codeGroup: 'GoalType' });
    const { getCodeDescription: getKpiTypeCodeDescription } = useCodeList({ codeGroup: 'KpiType' });

    // useEffect(() => {
    //     if (fetchLocations) {
    //         fetchLocations();
    //     }
    // }, [fetchLocations]);

    // useEffect(() => {
    //     if (campaign?.adGroups?.length) {
    //         if (getCampaignAudienceSources) {
    //             setAudienceSources(getCampaignAudienceSources(campaign));
    //         }
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [campaign.adGroups, selections]);

    // useEffect(() => {
    //     if (campaign?.adGroups?.length) {
    //         if (getCampaignInventorySources) {
    //             setInventorySources(getCampaignInventorySources(campaign));
    //         }
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [campaign.adGroups, inventorySourceSelections]);

    // useEffect(() => {
    //     if (campaign?.adGroups?.length) {
    //         if (getCampaignLocations) {
    //             setLocations(getCampaignLocations(campaign));
    //         }
    //         if (getCampaignGeoLocations) {
    //             setGeoLocations(getCampaignGeoLocations(campaign));
    //         }
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [campaign.adGroups, locationSelections]);

    const activeFlightsBudget = (() => {
        if (!campaign.flights?.length) return campaign.budget;
        const now = new Date();
        return campaign.flights
            .filter((f) => !f.endDateTime || new Date(f.endDateTime) >= now)
            .reduce((sum, f) => sum + (f.budgetAmount || 0), 0);
    })();

    return (
        <Column>
            <Card id="campaign-wizard-review-detailed-summary-setup" variant="outlined">
                <CardHeader
                    title={
                        <Stack direction="row" spacing={0.5} alignItems="center">
                            <Typography variant="body1" color="text.primary">
                                Campaign Summary
                            </Typography>
                        </Stack>
                    }
                />
                <CardContent>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TablePrimaryCell>Advertiser Name</TablePrimaryCell>
                                <TableCell>{campaign?.dealer?.dealerName}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePrimaryCell>Product Category</TablePrimaryCell>
                                <TableCell>{productCategory?.name}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePrimaryCell>Media Type</TablePrimaryCell>
                                <TableCell>{campaign.mediaType}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePrimaryCell>Campaign Strategy</TablePrimaryCell>
                                <TableCell>{campaign.strategyType}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePrimaryCell sx={{ verticalAlign: 'top' }}>Inventory Source</TablePrimaryCell>
                                <TableCell>
                                    <Column>
                                        <InventorySourceField items={inventorySourceTargetQuery?.data || []} />
                                    </Column>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePrimaryCell>Campaign Goal</TablePrimaryCell>
                                <TableCell>{campaign.goal}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePrimaryCell>Start & End Date</TablePrimaryCell>
                                <TableCell>{`${Utils.formatESTDateLong(campaign.startDate)} - ${Utils.formatESTDateLong(
                                    campaign.endDate
                                )}`}</TableCell>
                            </TableRow>
                            {!!campaign.impressionGoal && (
                                <TableRow>
                                    <TablePrimaryCell>Impression Goal</TablePrimaryCell>
                                    <TableCell>{Utils.formatValue(campaign.impressionGoal)}</TableCell>
                                </TableRow>
                            )}
                            <TableRow>
                                <TablePrimaryCell>Budget</TablePrimaryCell>
                                <TableCell>{Utils.formatCurrency(activeFlightsBudget)}</TableCell>
                            </TableRow>
                            {campaign.flights && campaign.flights.length > 0 && (
                                <TableRow>
                                    <TablePrimaryCell sx={{ verticalAlign: 'top' }}>
                                        Budget and Flights
                                    </TablePrimaryCell>
                                    <TableCell>
                                        <Table
                                            size="small"
                                            sx={{
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                '& .MuiTableCell-root': {
                                                    borderBottom: '1px solid',
                                                    borderColor: 'divider',
                                                },
                                            }}
                                        >
                                            <TableBody>
                                                <TableRow
                                                    sx={{
                                                        backgroundColor: 'grey.100',
                                                        '& .MuiTableCell-root': {
                                                            fontWeight: 600,
                                                        },
                                                    }}
                                                >
                                                    <TableCell sx={{ width: '80px' }}>Flight No.</TableCell>
                                                    <TableCell sx={{ width: '100px' }}>Status</TableCell>
                                                    <TableCell sx={{ width: '100px' }}>Budget</TableCell>
                                                    <TableCell sx={{ width: '100px' }}>Spent</TableCell>
                                                    <TableCell sx={{ width: '100px' }}>Remaining</TableCell>
                                                    {userContext.isAdmin() && (
                                                        <TableCell sx={{ width: '120px' }}>Impression Goal</TableCell>
                                                    )}
                                                    <TableCell sx={{ width: '120px' }}>Start Date</TableCell>
                                                    <TableCell sx={{ width: '120px' }}>End date</TableCell>
                                                </TableRow>
                                                {((): JSX.Element[] => {
                                                    const now = new Date();

                                                    const allFlightsSorted = [...campaign.flights].sort(
                                                        (a, b) =>
                                                            new Date(a.startDateTime).getTime() -
                                                            new Date(b.startDateTime).getTime()
                                                    );

                                                    const completedCount = allFlightsSorted.filter((f) => {
                                                        if (!f.endDateTime) return false;
                                                        const end = new Date(f.endDateTime);
                                                        return end < now;
                                                    }).length;

                                                    const activeFlights = allFlightsSorted.filter((f) => {
                                                        if (!f.endDateTime) return true;
                                                        const end = new Date(f.endDateTime);
                                                        return end >= now;
                                                    });

                                                    const displayFlights = [...activeFlights].reverse();

                                                    return displayFlights.map((flight, index) => {
                                                        const remaining = flight.budgetAmount - flight.totalCost;

                                                        const displayIndex =
                                                            activeFlights.length + completedCount - index;

                                                        return (
                                                            <TableRow
                                                                key={flight.id || index}
                                                                sx={{
                                                                    backgroundColor:
                                                                        index % 2 === 0 ? 'transparent' : 'grey.50',
                                                                }}
                                                            >
                                                                <TableCell>
                                                                    <Typography color="primary" variant="body2">
                                                                        {displayIndex}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>
                                                                    {getFlightStatusBadge(
                                                                        flight.startDateTime,
                                                                        flight.endDateTime
                                                                    )}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {Utils.formatCurrency(flight.budgetAmount)}
                                                                </TableCell>
                                                                <TableCell>
                                                                    {Utils.formatCurrency(flight.totalCost)}
                                                                </TableCell>
                                                                <TableCell>{Utils.formatCurrency(remaining)}</TableCell>
                                                                {userContext.isAdmin() && (
                                                                    <TableCell>
                                                                        <Typography color="primary" variant="body2">
                                                                            {flight.impressionGoal != null &&
                                                                            flight.impressionGoal > 0
                                                                                ? flight.impressionGoal.toLocaleString()
                                                                                : '-'}
                                                                        </Typography>
                                                                    </TableCell>
                                                                )}
                                                                <TableCell>
                                                                    <Typography color="primary" variant="body2">
                                                                        {Utils.formatESTDate(flight.startDateTime)}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Typography color="primary" variant="body2">
                                                                        {Utils.formatESTDate(flight.endDateTime)}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    });
                                                })()}

                                                {campaign.flights.length > 1 &&
                                                    ((): JSX.Element | null => {
                                                        const now = new Date();

                                                        const activeFlightsForSummary = campaign.flights.filter((f) => {
                                                            if (!f.endDateTime) return true;
                                                            const end = new Date(f.endDateTime);
                                                            return end >= now;
                                                        });

                                                        if (activeFlightsForSummary.length <= 1) return null;

                                                        const summary = calculateFlightSummary(activeFlightsForSummary);
                                                        return (
                                                            <TableRow
                                                                sx={{
                                                                    backgroundColor: 'primary.light',
                                                                    '& .MuiTableCell-root': {
                                                                        fontWeight: 600,
                                                                        color: 'primary.main',
                                                                    },
                                                                }}
                                                            >
                                                                <TableCell>
                                                                    <Typography
                                                                        color="primary"
                                                                        variant="body2"
                                                                        fontWeight={600}
                                                                    >
                                                                        Total
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell></TableCell>
                                                                <TableCell>
                                                                    <Typography
                                                                        color="primary"
                                                                        variant="body2"
                                                                        fontWeight={600}
                                                                    >
                                                                        {Utils.formatCurrency(
                                                                            summary.totalBudgetAmount
                                                                        )}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Typography
                                                                        color="primary"
                                                                        variant="body2"
                                                                        fontWeight={600}
                                                                    >
                                                                        {Utils.formatCurrency(summary.totalCost)}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Typography
                                                                        color="primary"
                                                                        variant="body2"
                                                                        fontWeight={600}
                                                                    >
                                                                        {Utils.formatCurrency(summary.totalRemaining)}
                                                                    </Typography>
                                                                </TableCell>
                                                                {userContext.isAdmin() && (
                                                                    <TableCell>
                                                                        <Typography
                                                                            color="primary"
                                                                            variant="body2"
                                                                            fontWeight={600}
                                                                        >
                                                                            {(() => {
                                                                                const total =
                                                                                    activeFlightsForSummary.reduce(
                                                                                        (sum, f) =>
                                                                                            sum +
                                                                                            (f.impressionGoal ?? 0),
                                                                                        0
                                                                                    );
                                                                                return total > 0
                                                                                    ? total.toLocaleString()
                                                                                    : '-';
                                                                            })()}
                                                                        </Typography>
                                                                    </TableCell>
                                                                )}
                                                                <TableCell>
                                                                    <Typography
                                                                        color="primary"
                                                                        variant="body2"
                                                                        fontWeight={600}
                                                                    >
                                                                        {summary.earliestStartDate
                                                                            ? Utils.formatESTDate(
                                                                                  summary.earliestStartDate
                                                                              )
                                                                            : '-'}
                                                                    </Typography>
                                                                </TableCell>
                                                                <TableCell>
                                                                    <Typography
                                                                        color="primary"
                                                                        variant="body2"
                                                                        fontWeight={600}
                                                                    >
                                                                        {summary.latestEndDate
                                                                            ? Utils.formatESTDate(summary.latestEndDate)
                                                                            : '-'}
                                                                    </Typography>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })()}
                                            </TableBody>
                                        </Table>
                                    </TableCell>
                                </TableRow>
                            )}
                            <TableRow>
                                <TablePrimaryCell>Budget Cap</TablePrimaryCell>
                                <TableCell>
                                    {campaign.budgetCapType !== 'CUSTOM' && (
                                        <CapitalizeTypography>
                                            {Utils.convertCase(campaign.budgetCapType)}
                                        </CapitalizeTypography>
                                    )}
                                    {campaign.budgetCapType === 'CUSTOM' && (
                                        <>
                                            <CapitalizeTypography component="span">
                                                {Utils.convertCase(campaign.budgetCapRecurrenceTimePeriod)}
                                            </CapitalizeTypography>
                                            {', '}
                                            <Typography component="span" variant="body2">
                                                {Utils.formatCurrency(campaign.budgetCapAmount, 2)}
                                            </Typography>
                                        </>
                                    )}
                                </TableCell>
                            </TableRow>
                            {false && (
                                <TableRow>
                                    <TablePrimaryCell>Campaign Goal</TablePrimaryCell>
                                    <TableCell>{getGoalTypeCodeDescription(campaign.goal)}</TableCell>
                                </TableRow>
                            )}
                            {false && (
                                <TableRow>
                                    <TablePrimaryCell>KPI</TablePrimaryCell>
                                    <TableCell>{getKpiTypeCodeDescription(campaign.kpi)}</TableCell>
                                </TableRow>
                            )}
                            {false && (
                                <TableRow>
                                    <TablePrimaryCell>KPI Target</TablePrimaryCell>
                                    <TableCell>
                                        {campaign.targetKpiDisabled ? (
                                            <>Not set</>
                                        ) : (
                                            <>{Utils.formatValue(campaign.targetKpi, 'percent')}</>
                                        )}
                                    </TableCell>
                                </TableRow>
                            )}
                            {false && (
                                <TableRow>
                                    <TablePrimaryCell>Bidding Priority</TablePrimaryCell>
                                    <TableCell>{campaignBidStrategyLabel ?? '-'}</TableCell>
                                </TableRow>
                            )}
                            {false && (
                                <TableRow>
                                    <TablePrimaryCell>Budget Management Strategy</TablePrimaryCell>
                                    <TableCell>{campaignBudgetManagementStrategyLabel ?? '-'}</TableCell>
                                </TableRow>
                            )}
                            <TableRow>
                                <TablePrimaryCell>Frequency</TablePrimaryCell>
                                <TableCell>
                                    <CampaignFrequencySummary campaign={campaign} />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>

            <Card id="campaign-wizard-review-detailed-summary-targeting" variant="outlined">
                <CardHeader
                    title={
                        <Stack direction="row" spacing={0.5} alignItems="center">
                            <Typography variant="body1" color="text.primary">
                                Targeting
                            </Typography>
                        </Stack>
                    }
                />
                <CardContent>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TablePrimaryCell>Radius</TablePrimaryCell>
                                <TableCell>
                                    <Column gap={2}>
                                        <Typography variant="body2">{campaign.zipcodeRadius} Miles</Typography>
                                    </Column>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePrimaryCell>Locations</TablePrimaryCell>
                                <TableCell>
                                    <Column gap={2}>
                                        <Typography variant="body2">
                                            {locationTargetCount > 1
                                                ? `${locationTargetCount} Locations`
                                                : `${locationTargetCount} Location`}
                                        </Typography>

                                        <Card variant="outlined">
                                            <Box
                                                sx={{
                                                    height: 200,
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                <LocationList
                                                    items={
                                                        locationTargetQuery?.data?.map((x) =>
                                                            DspGeoLocationUtils.toLocation(x)
                                                        ) || []
                                                    }
                                                />
                                            </Box>
                                        </Card>
                                    </Column>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePrimaryCell>Zip Codes</TablePrimaryCell>
                                <TableCell>
                                    <Column gap={2}>
                                        <Typography variant="body2">
                                            {geoLocationTargetCount > 1
                                                ? `${geoLocationTargetCount} Zip Codes`
                                                : `${geoLocationTargetCount} Zip Code`}
                                        </Typography>

                                        <Card variant="outlined">
                                            <Box
                                                sx={{
                                                    height: 200,
                                                    overflowY: 'auto',
                                                }}
                                            >
                                                <LocationList
                                                    items={
                                                        geoLocationTargetQuery?.data?.map((x) =>
                                                            DspGeoLocationUtils.toLocation(x)
                                                        ) || []
                                                    }
                                                />
                                            </Box>
                                        </Card>
                                    </Column>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePrimaryCell>Audience Type</TablePrimaryCell>
                                <TableCell>
                                    <Column gap={2}>
                                        <CampaignAudienceTypeSummary
                                            campaign={campaign}
                                            slotProps={{
                                                typography: {
                                                    variant: 'body2',
                                                },
                                            }}
                                        />
                                    </Column>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePrimaryCell>Audience</TablePrimaryCell>
                                <TableCell>
                                    <Column gap={2}>
                                        <Typography variant="body2">
                                            {audienceSourceTargetCount > 1
                                                ? `${audienceSourceTargetCount} Audiences`
                                                : `${audienceSourceTargetCount} Audience`}
                                        </Typography>

                                        <AudienceSourceField
                                            items={
                                                audienceSourceTargetQuery?.data?.map((x) =>
                                                    DspAudienceSourceUtils.toAudienceSource(x)
                                                ) || []
                                            }
                                        />
                                    </Column>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>

            <Card id="campaign-wizard-review-detailed-summary-creative" variant="outlined">
                <CardHeader
                    title={
                        <Stack direction="row" spacing={0.5} alignItems="center">
                            <Typography variant="body1" color="text.primary">
                                Creative
                            </Typography>
                        </Stack>
                    }
                />
                <CardContent>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TablePrimaryCell>Creative Type</TablePrimaryCell>
                                <TableCell>{getCampaignTypeCodeDescription(campaign.campaignType)}</TableCell>
                            </TableRow>
                            {campaign.campaignType === 'Static' && (
                                <>
                                    <TableRow>
                                        <TablePrimaryCell>Creative</TablePrimaryCell>
                                        <TableCell>
                                            <CampaignCreativeAssets campaign={campaign} readOnly={true} />
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TablePrimaryCell>Destination URL</TablePrimaryCell>
                                        <TableCell>{campaign.landingPage ?? 'Not set'}</TableCell>
                                    </TableRow>

                                    {campaign.callToActions && (
                                        <TableRow>
                                            <TablePrimaryCell>Call to Actions</TablePrimaryCell>
                                            <TableCell>{campaign.callToActions ?? 'Not set'}</TableCell>
                                        </TableRow>
                                    )}
                                </>
                            )}
                            {campaign.campaignType === 'AdTag' && (
                                <>
                                    <TableRow>
                                        <TablePrimaryCell>Ad Tag URL</TablePrimaryCell>
                                        <TableCell>{campaign.adTagUrl ?? 'Not set'}</TableCell>
                                    </TableRow>
                                </>
                            )}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </Column>
    );
}
